/*
 * @Descripttion: 客户回款明细页面reducer
 * @Author: 曹博
 * @Date: 2023-09-22 10:58:53
 * @LastEditors: 曹博
 * @LastEditTime: 2023-09-26 10:50:20
 */
import { CustomerPayback } from '../../api/paymentOrder'
import { ActionType, CustomAction } from '../../global'

interface platform {
  label: string
  value: string
}

interface State {
  platformList: platform[]
  dataSource: CustomerPayback[]
  loading: boolean
  formData: {
    platform?: string
    customer?: string
  }
}

export const initState: State = {
  platformList: [],
  dataSource: [],
  loading: false,
  formData: {},
}

type Action = ActionType<State>

const reducer = (state: State, action: CustomAction<Action>): State => {
  let newstate = { ...state }
  switch (action.type) {
    case 'setPlatformListAction':
      newstate.platformList = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}
export default reducer

export const setPlatformListAction = (
  param: platform[],
): CustomAction<Action> => ({
  type: 'setPlatformListAction',
  payload: param,
})

// 设置表格数据
export const setDataSourceAction = (
  param: CustomerPayback[],
): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 页面loading
export const setLoadingAction = (param: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: param,
})

// 搜索表单参数
export const setFormDataAction = (param: {
  platform: string
  customer: string
}): CustomAction<Action> => ({
  type: 'setFormDataAction',
  payload: param,
})

// 重载数据
export const reloadStateAction = (param: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})
/*
 * @Descripttion: 客户回款明细页面reducer
 * @Author: 曹博
 * @Date: 2023-09-22 10:58:53
 * @LastEditors: 曹博
 * @LastEditTime: 2023-09-26 10:50:20
 */
import { CustomerPayback } from '../../api/paymentOrder'
import { ActionType, CustomAction } from '../../global'

interface platform {
  label: string
  value: string
}

interface State {
  platformList: platform[]
  dataSource: CustomerPayback[]
  loading: boolean
  formData: {
    platform?: string
    customer?: string
  }
}

export const initState: State = {
  platformList: [],
  dataSource: [],
  loading: false,
  formData: {},
}

type Action = ActionType<State>

const reducer = (state: State, action: CustomAction<Action>): State => {
  let newstate = { ...state }
  switch (action.type) {
    case 'setPlatformListAction':
      newstate.platformList = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}
export default reducer

export const setPlatformListAction = (
  param: platform[],
): CustomAction<Action> => ({
  type: 'setPlatformListAction',
  payload: param,
})

// 设置表格数据
export const setDataSourceAction = (
  param: CustomerPayback[],
): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 页面loading
export const setLoadingAction = (param: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: param,
})

// 搜索表单参数
export const setFormDataAction = (param: {
  platform: string
  customer: string
}): CustomAction<Action> => ({
  type: 'setFormDataAction',
  payload: param,
})

// 重载数据
export const reloadStateAction = (param: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})
